import { ShopModule } from "../types/shopModuleTypes";
import { doApiGet, CallResult } from "./Requests";

export const shopModulesApi = {
  getEmployeeShopModules: async (): Promise<CallResult<ShopModule[]>> => {
    return await doApiGet<ShopModule[]>(`/api/employee/current/shopmodules`);
  },
  getCompanyShopModules: async (): Promise<CallResult<ShopModule[]>> => {
    return await doApiGet<ShopModule[]>(`/api/companies/current/shopmodules`);
  },

  getShopModulesFilteredByVisibility: (
      isCompanyWideAssigned: boolean,
      groupIds: number[],
      employeeUserIds: string[]
  ): Promise<CallResult<ShopModule[]>> => {
    const params = new URLSearchParams();
    params.append("isCompanyWideAssigned", String(isCompanyWideAssigned));
    groupIds.forEach(id => params.append("groupIds", String(id)));
    employeeUserIds.forEach(id => params.append("employeeUserIds", id));

    return doApiGet<ShopModule[]>(`/api/companies/current/shopmodules/filtered?${params.toString()}`);
  },

};